/* eslint-disable @typescript-eslint/no-explicit-any */
// @app/api/core/tryParseApiEnvelopeFromBlob.ts
export type ApiEnvelopeLike = { code?: number; data?: any; error?: any };

export async function tryParseApiEnvelopeFromBlob(
  blob: Blob
): Promise<ApiEnvelopeLike | null> {
  try {
    const text = await blob.text();
    const parsed = JSON.parse(text);

    const looksLikeEnvelope =
      parsed &&
      typeof parsed === 'object' &&
      Object.prototype.hasOwnProperty.call(parsed, 'code') &&
      Object.prototype.hasOwnProperty.call(parsed, 'data') &&
      Object.prototype.hasOwnProperty.call(parsed, 'error');

    return looksLikeEnvelope ? (parsed as ApiEnvelopeLike) : null;
  } catch {
    return null;
  }
}
